import { useEffect, useState } from 'react';
import { useTutorial } from '@/contexts/TutorialContext';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Mail } from 'lucide-react';

export const CheckEmailDialog = () => {
  const { isActive, currentStepData, nextStep, previousStep } = useTutorial();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isActive && currentStepData?.id === 'check-email') {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [isActive, currentStepData]);

  const handleContinue = () => {
    setOpen(false);
    nextStep();
  };

  const handleBack = () => {
    setOpen(false);
    previousStep();
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => {
      if (!isOpen) {
        handleBack();
      }
    }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-primary/10">
            <Mail className="w-6 h-6 text-primary" />
          </div>
          <DialogTitle className="text-center">Invitation Sent!</DialogTitle>
          <DialogDescription className="text-center space-y-2">
            <p>
              Your teammate should now check their email for the invitation.
            </p>
            <p className="text-sm text-muted-foreground">
              <strong>Important:</strong> Ask them to check their spam folder if they don't see it in their inbox.
            </p>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-row gap-2 sm:justify-center">
          <Button variant="outline" onClick={handleBack} className="flex-1 sm:flex-none">
            Back
          </Button>
          <Button onClick={handleContinue} className="flex-1 sm:flex-none">
            Got it, Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
